module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Typeahead"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.idCompanyClient),
      expression: "idCompanyClient"
    }],
    staticClass: "input-group  input-group input-group-md"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "form-control",
    staticStyle: {
      "font-family": "FontAwesome"
    },
    attrs: {
      "type": "text",
      "id": "userclient-typeahead",
      "placeholder": "Mitarbeiter - Abteilung - Thema suchen...",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        return _vm.down($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        return _vm.up($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.reset($event)
      }],
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.hit($event)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }, _vm.update]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onClickFindAll
    }
  }, [(_vm.query) ? _c('span', {
    staticClass: "glyphicon glyphicon glyphicon-eye-close",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('span', {
    staticClass: "glyphicon glyphicon glyphicon-eye-open",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-right",
    staticStyle: {
      "background-color": "#fff"
    }
  }, [_c('li', [_c('a', {
    on: {
      "click": _vm.onClickNew
    }
  }, [_vm._v("Mitarbeiter - Abteilung - Thema anlegen")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDirty && !_vm.hasItems && !_vm.loading),
      expression: "isDirty && !hasItems && !loading"
    }],
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("Kein Mitarbeiter - Abteilung - Thema gefunden\n  ")]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasItems),
      expression: "hasItems"
    }]
  }, _vm._l((_vm.items), function(item, index) {
    return _c('li', {
      class: _vm.activeClass(index),
      on: {
        "mousedown": _vm.hit,
        "mousemove": function($event) {
          return _vm.setActive(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lg",
      class: _vm.userClientType[item.idSex].class,
      attrs: {
        "title": _vm.userClientType[item.idSex].text
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "name",
      domProps: {
        "textContent": _vm._s(_vm.userClientType[item.idSex].sexText)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "name",
      domProps: {
        "innerHTML": _vm._s(_vm.highlight(item.firstName))
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "name",
      domProps: {
        "innerHTML": _vm._s(_vm.highlight(item.lastName))
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.department),
        expression: "item.department"
      }]
    }, [_vm._v(", "), _c('i', {
      staticClass: "fa fa-users",
      attrs: {
        "title": "Abteilung"
      }
    }), _c('span', {
      staticClass: "screen-name",
      domProps: {
        "innerHTML": _vm._s(_vm.highlight(item.department))
      }
    })]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.function),
        expression: "item.function"
      }]
    }, [_vm._v(", "), _c('i', {
      staticClass: "fa fa-cogs",
      attrs: {
        "title": "Funktion"
      }
    }), _c('span', {
      staticClass: "screen-name",
      domProps: {
        "innerHTML": _vm._s(_vm.highlight(item.function))
      }
    })]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.room),
        expression: "item.room"
      }]
    }, [_vm._v(", "), _c('i', {
      staticClass: "fa fa-map-marker",
      attrs: {
        "title": "Zimmer/Ort"
      }
    }), _c('span', {
      staticClass: "screen-name",
      domProps: {
        "innerHTML": _vm._s(_vm.highlight(item.room))
      }
    })]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.template),
        expression: "item.template"
      }]
    }, [_vm._v(", "), _c('i', {
      staticClass: "fa fa-file-text",
      attrs: {
        "title": item.template
      }
    })])])
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "title": "Mitarbeiter"
    }
  }), _vm._v(" - \n      "), _c('i', {
    staticClass: "fa fa-users",
    attrs: {
      "title": "Abteilung"
    }
  }), _vm._v(" - \n      "), _c('i', {
    staticClass: "fa fa-commenting",
    attrs: {
      "title": "Thema"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-primary dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-menu-hamburger",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-32b62b5e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/UserClientTypeahead.vue
// module id = 268
// module chunks = 0